import { confidenceBadgeStyle, getConfidenceBadgeLabel } from '../../constants/confidenceBadge';

/**
 * Pill label for high / medium / low confidence — park-v4 `.confidence-badge`
 */
export default function ConfidenceBadge({
    confidence,
    label,
    labelVariant = 'default',
    solid = false,
    className,
    style,
}) {
    if (!confidence && !label) return null;

    const level = confidence ?? 'low';

    return (
        <span
            className={className}
            style={{ ...confidenceBadgeStyle(level, { solid }), ...style }}
        >
            {label ?? getConfidenceBadgeLabel(level, { variant: labelVariant })}
        </span>
    );
}
